import { useTheme } from '../../theme/ThemeContext';
const JUSTIFY_MAP = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end',
  between: 'space-between'
};
const ROW_ALIGN_MAP = {
  start: 'flex-start',
  center: 'center',
  end: 'flex-end'
};
export const useRowStyles = ({
  gap,
  justify,
  align,
  wrap,
  isCollapsed
}) => {
  const theme = useTheme();
  const SPACING_MAP = {
    '100': theme.spacing['100'],
    '200': theme.spacing['200'],
    '300': theme.spacing['300'],
    '400': theme.spacing['400']
  };
  return Object.assign({
    display: 'flex',
    flexDirection: isCollapsed ? 'column' : 'row',
    flexWrap: wrap ? 'wrap' : 'nowrap'
  }, gap && {
    gap: SPACING_MAP[gap]
  }, !isCollapsed && justify && {
    justifyContent: JUSTIFY_MAP[justify]
  }, align && {
    alignItems: ROW_ALIGN_MAP[align]
  });
};